import React, { useRef, useState } from "react";
import { useParams } from "react-router";
import Navigation from "../../components/Navigation/Navigation";
import "./qrCode.css";
import QRCodeReact from "qrcode.react";
import { CompactPicker } from "react-color";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const QRCode = () => {
  const { slug } = useParams();
  const url = `https://digitalmenus.co/menus/${slug}`;
  const [qrColor, setQRColor] = useState("#000000");
  const qrCodeRef = useRef();

  const handleColorChange = (color) => {
    setQRColor(color.hex);
  };

  const downloadQRCode = (format) => {
    const canvas = qrCodeRef.current.querySelector("canvas");

    if (format === "png") {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = "qrcode.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (format === "pdf") {
      html2canvas(canvas).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 15, 40, 180, 180);
        pdf.save("qrcode.pdf");
      });
    }
  };

  return (
    <Navigation>
      <h1 className="page-content-h">QR Code Generator</h1>
      <p className="page-content-p">
        Customize and download your digital menu QR code.
      </p>

      <div className="languages-container">
        <div className="qr-code-div" ref={qrCodeRef}>
          <QRCodeReact
            value={url}
            size={256}
            fgColor={qrColor}
            style={{ width: "100%", height: "100%" }}
          />
        </div>
        <CompactPicker color={qrColor} onChangeComplete={handleColorChange} />

        <div className="qr-code-btns-div">
          <div onClick={() => downloadQRCode("png")} className="qr-code-btn">
            Download PNG
          </div>
          <div onClick={() => downloadQRCode("pdf")} className="qr-code-btn">
            Download PDF
          </div>
        </div>
      </div>
    </Navigation>
  );
};

export default QRCode;
